import React, { useRef } from "react";
import { Link } from "react-router-dom";

const SectionCarousel = ({
  title,
  subtitle,
  viewAllTo,
  viewAllState,
  viewAllLabel = "View all",
  emptyTitle = "Nothing to show yet.",
  emptyText = "Check back soon.",
  children,
  className = "",
}) => {
  const trackRef = useRef(null);
  const items = React.Children.toArray(children).filter(Boolean);
  const hasMultipleItems = items.length > 1;
  const sectionClasses = [
    "section-carousel",
    items.length === 0 ? "section-carousel-empty" : "",
    items.length === 1 ? "section-carousel-single" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const scrollByCards = (direction) => {
    const track = trackRef.current;
    if (!track) return;

    const firstCard = track.querySelector(".section-carousel-item");
    const distance =
      firstCard?.getBoundingClientRect().width || Math.min(track.clientWidth, 320);

    track.scrollBy({
      left: direction * (distance + 16),
      behavior: "smooth",
    });
  };

  return (
    <section className={sectionClasses}>
      <div className="section-carousel-header">
        <div>
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        <div className="section-carousel-actions">
          {viewAllTo && (
            <Link to={viewAllTo} state={viewAllState} className="dashboard-link-button">
              {viewAllLabel}
            </Link>
          )}
          {hasMultipleItems && (
            <div className="section-carousel-arrows" aria-label={`${title} carousel controls`}>
              <button
                type="button"
                aria-label={`Scroll ${title} left`}
                onClick={() => scrollByCards(-1)}
              >
                &lt;
              </button>
              <button
                type="button"
                aria-label={`Scroll ${title} right`}
                onClick={() => scrollByCards(1)}
              >
                &gt;
              </button>
            </div>
          )}
        </div>
      </div>

      {items.length === 0 ? (
        <div className="dashboard-empty compact">
          <strong>{emptyTitle}</strong>
          <p>{emptyText}</p>
        </div>
      ) : (
        <div className="section-carousel-track" ref={trackRef}>
          {items.map((child, index) => (
            <div className="section-carousel-item" key={child.key || index}>
              {child}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default SectionCarousel;
